import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgComboInsightsHorizontalBorderPositive = (props) => /* @__PURE__ */ _jsx("svg", {
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M55.5046 6.76599C56.6664 7.00539 57.5 8.02831 57.5 9.21454V33C57.5 33.8284 56.8284 34.5 56 34.5H4C3.17157 34.5 2.5 33.8284 2.5 33V9.21455C2.5 8.02831 3.33362 7.00539 4.49545 6.76599L29.6973 1.57289C29.897 1.53173 30.103 1.53173 30.3027 1.57289L55.5046 6.76599Z" })
});
export default SvgComboInsightsHorizontalBorderPositive;
